import { ApplicationInsights } from '@microsoft/applicationinsights-web';
 
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
        enableAutoRouteTracking: true,
    }
});
 
appInsights.loadAppInsights();

const cloudRoleName = process.env.REACT_APP_CLOUD_ROLE_NAME;
 
appInsights.addTelemetryInitializer((envelope) => {
  if (
    envelope &&
    envelope.tags &&
    !envelope.tags["ai.cloud.role"]
  ) {
    envelope.tags["ai.cloud.role"] = cloudRoleName;
  }
});
 

appInsights.trackPageView(); // Manually call this for SPAs
 
// Make it available globally if needed
window.appInsights = appInsights;
 
export default appInsights;